export const VideoMuteIcon = () => {
  return (
    <span className="p-[3px] bg-[#0000005C] inline-block rounded-[8px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path d="M15 8L19 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M19 8L15 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M2 10.2168C2 9.57408 2 9.25269 2.0858 8.99296C2.25466 8.48184 2.65561 8.08088 3.16674 7.91202C3.42647 7.82622 3.74785 7.82622 4.39062 7.82622H5.60045C5.83904 7.82622 5.95834 7.82622 6.06858 7.79603C6.16625 7.76928 6.25835 7.72529 6.34054 7.66614C6.43332 7.59937 6.5083 7.50658 6.65825 7.32101L8.0822 5.55887C8.8245 4.64028 9.19565 4.18098 9.52082 4.13098C9.80231 4.0877 10.0868 4.18827 10.2785 4.39885C10.5 4.64211 10.5 5.23263 10.5 6.41366V14.02C10.5 15.2011 10.5 15.7916 10.2785 16.0348C10.0868 16.2454 9.80231 16.346 9.52082 16.3027C9.19565 16.2527 8.8245 15.7934 8.0822 14.8748L6.65825 13.1127C6.5083 12.9271 6.43332 12.8343 6.34054 12.7676C6.25835 12.7084 6.16625 12.6644 6.06858 12.6377C5.95834 12.6075 5.83904 12.6075 5.60045 12.6075H4.39062C3.74785 12.6075 3.42647 12.6075 3.16674 12.5217C2.65561 12.3528 2.25466 11.9519 2.0858 11.4407C2 11.181 2 10.8596 2 10.2168Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export const VideoUnmuteIcon = () => {
  return (
    <span className="p-[3px] bg-[#0000005C] inline-block rounded-[8px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.297 4.00049C17.1462 4.79242 17.8242 5.74996 18.2891 6.81403C18.754 7.8781 18.9959 9.02614 18.9999 10.1873C19.004 11.3485 18.7701 12.4982 18.3127 13.5655C17.8552 14.6328 17.1839 15.595 16.3402 16.3929M13.9782 6.48709C14.4877 6.96225 14.8945 7.53677 15.1735 8.17521C15.4524 8.81366 15.5975 9.50248 15.6 10.1992C15.6024 10.8959 15.4621 11.5857 15.1876 12.2261C14.9131 12.8665 14.5104 13.4438 14.0041 13.9225M6.65825 13.1128L8.0822 14.875C8.8245 15.7936 9.19565 16.2529 9.52082 16.3029C9.80231 16.3461 10.0868 16.2456 10.2785 16.035C10.5 15.7917 10.5 15.2012 10.5 14.0202V6.41381C10.5 5.23278 10.5 4.64226 10.2785 4.399C10.0868 4.18841 9.80231 4.08784 9.52082 4.13113C9.19565 4.18112 8.8245 4.64042 8.0822 5.55902L6.65825 7.32116C6.5083 7.50673 6.43332 7.59952 6.34054 7.66628C6.25835 7.72543 6.16625 7.76942 6.06858 7.79617C5.95834 7.82637 5.83904 7.82637 5.60045 7.82637H4.39063C3.74785 7.82637 3.42647 7.82637 3.16674 7.91217C2.65561 8.08103 2.25466 8.48198 2.0858 8.99311C2 9.25284 2 9.57422 2 10.217C2 10.8598 2 11.1812 2.0858 11.4409C2.25466 11.952 2.65561 12.353 3.16674 12.5218C3.42647 12.6076 3.74785 12.6076 4.39063 12.6076H5.60045C5.83904 12.6076 5.95834 12.6076 6.06858 12.6378C6.16625 12.6646 6.25835 12.7086 6.34054 12.7677C6.43332 12.8345 6.5083 12.9273 6.65825 13.1128Z"
          stroke="#EAEAEA"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export const LoadingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g data-figma-bg-blur-radius="4">
        <circle cx="19.8604" cy="18.1944" r="12.1944" stroke="white" strokeWidth="2" />
        <path
          d="M31.6929 18.9168C32.4315 18.9619 33.074 18.3986 33.044 17.6592C32.986 16.2314 32.6964 14.8195 32.1836 13.4793C31.5108 11.721 30.4696 10.1271 29.1299 8.80455C27.7901 7.48199 26.1829 6.46143 24.4161 5.81143C23.0695 5.316 21.6539 5.04458 20.2255 5.00505C19.4857 4.98458 18.9307 5.63427 18.9854 6.37227C19.04 7.11028 19.6843 7.65532 20.4232 7.69494C21.4691 7.751 22.5032 7.96314 23.4908 8.32649C24.8988 8.84447 26.1796 9.65775 27.2472 10.7117C28.3148 11.7656 29.1446 13.0358 29.6807 14.437C30.0567 15.4198 30.2822 16.4511 30.3518 17.4961C30.4009 18.2345 30.9542 18.8717 31.6929 18.9168Z"
          fill="#3B49FF"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            from="0 19.8604 18.1944"
            to="360 19.8604 18.1944"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </path>
      </g>
      <defs>
        <clipPath id="bgblur_0_8446_27211_clip_path" transform="translate(4 4)">
          <rect width="40" height="40" rx="4" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <path
        d="M13.5 8.00024V15.5627M13.5 19.8252V19.6877M25.875 13.5002C25.875 20.3348 20.3345 25.8752 13.5 25.8752C6.66548 25.8752 1.125 20.3348 1.125 13.5002C1.125 6.66572 6.66548 1.12524 13.5 1.12524C20.3345 1.12524 25.875 6.66572 25.875 13.5002Z"
        stroke="#DF3F1F"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ReviewFailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
    >
      <path
        d="M8.90402 23.2488L1.97909 18.2914C1.46118 17.9201 1.03923 17.4307 0.748205 16.8637C0.457186 16.2968 0.30548 15.6687 0.305664 15.0314V6.61884C0.305658 5.81152 0.549345 5.023 1.00484 4.35645C1.46034 3.6899 2.10642 3.17637 2.85857 2.88304L9.54157 0.275333C10.4794 -0.0898247 11.5202 -0.0898247 12.458 0.275333L19.141 2.88304C19.8932 3.17637 20.5393 3.6899 20.9948 4.35645C21.4503 5.023 21.694 5.81152 21.6939 6.61884V15.1009C21.6937 15.7195 21.5504 16.3296 21.2751 16.8835C20.9999 17.4375 20.6002 17.9202 20.1074 18.294L13.6663 23.1833C12.984 23.7012 12.1538 23.987 11.2973 23.9987C10.4408 24.0105 9.603 23.7477 8.90669 23.2488H8.90402ZM10.27 2.14123L3.58702 4.7476C3.20981 4.89342 2.88584 5.15048 2.65811 5.48469C2.43038 5.81889 2.30963 6.21443 2.3119 6.61884V15.0314C2.31192 15.3499 2.38782 15.6639 2.53333 15.9472C2.67883 16.2305 2.88975 16.4751 3.14861 16.6607L10.0709 21.6195C10.4114 21.8637 10.82 21.9951 11.2391 21.9951C11.6773 21.9965 12.1036 21.8527 12.4514 21.5861L18.8938 16.6968C19.1404 16.5099 19.3404 16.2684 19.4781 15.9913C19.6159 15.7142 19.6876 15.409 19.6877 15.0996V6.6175C19.6895 6.21302 19.5684 5.81753 19.3405 5.48338C19.1125 5.14924 18.7885 4.89219 18.4113 4.74626L11.7283 2.13989C11.2591 1.95841 10.7392 1.95841 10.27 2.13989V2.14123ZM12.9847 15.403L10.9998 13.4168L9.01495 15.403C8.82596 15.5875 8.57184 15.6902 8.30768 15.6886C8.04352 15.6871 7.79063 15.5814 7.60384 15.3946C7.41704 15.2078 7.31141 14.9549 7.30985 14.6908C7.30829 14.4266 7.41092 14.1725 7.59548 13.9835L9.58167 11.9987L7.59548 10.0138C7.50237 9.9206 7.42852 9.80997 7.37816 9.68823C7.3278 9.56648 7.30191 9.43601 7.30198 9.30427C7.30204 9.17252 7.32805 9.04207 7.37852 8.92038C7.429 8.79868 7.50295 8.68812 7.59615 8.595C7.78439 8.40695 8.03961 8.30137 8.30569 8.30149C8.43744 8.30156 8.56789 8.32757 8.68958 8.37804C8.81128 8.42852 8.92184 8.50247 9.01495 8.59567L10.9998 10.5805L12.9847 8.59567C13.0778 8.50247 13.1883 8.42852 13.31 8.37804C13.4317 8.32757 13.5622 8.30156 13.6939 8.30149C13.8257 8.30143 13.9561 8.32732 14.0779 8.37768C14.1996 8.42804 14.3103 8.50189 14.4035 8.595C14.4967 8.68812 14.5706 8.79868 14.6211 8.92038C14.6716 9.04207 14.6976 9.17252 14.6976 9.30427C14.6977 9.43601 14.6718 9.56648 14.6215 9.68823C14.5711 9.80997 14.4972 9.9206 14.4041 10.0138L12.4179 11.9987L14.4041 13.9835C14.5887 14.1725 14.6913 14.4266 14.6898 14.6908C14.6882 14.9549 14.5826 15.2078 14.3958 15.3946C14.209 15.5814 13.9561 15.6871 13.6919 15.6886C13.4278 15.6902 13.1736 15.5875 12.9847 15.403Z"
        fill="#DF3F1F"
      />
    </svg>
  );
};

export const MoreIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="26"
      width="26"
      height="26"
      rx="8"
      transform="rotate(-90 0 26)"
      fill="#F0F0FA"
    />
    <path
      d="M12.25 13C12.25 12.5858 12.5858 12.25 13 12.25C13.4142 12.25 13.75 12.5858 13.75 13C13.75 13.4142 13.4142 13.75 13 13.75C12.5858 13.75 12.25 13.4142 12.25 13Z"
      stroke="#5C5C5C"
      strokeWidth="1.5"
    />
    <path
      d="M18 13C18 12.5858 18.3358 12.25 18.75 12.25C19.1642 12.25 19.5 12.5858 19.5 13C19.5 13.4142 19.1642 13.75 18.75 13.75C18.3358 13.75 18 13.4142 18 13Z"
      stroke="#5C5C5C"
      strokeWidth="1.5"
    />
    <path
      d="M6.5 13C6.5 12.5858 6.83578 12.25 7.25 12.25C7.66421 12.25 8 12.5858 8 13C8 13.4142 7.66421 13.75 7.25 13.75C6.83578 13.75 6.5 13.4142 6.5 13Z"
      stroke="#5C5C5C"
      strokeWidth="1.5"
    />
  </svg>
);

export const UpgradeIcon = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.7157 0.787243C5.87224 0.629085 6.12776 0.629084 6.2843 0.787243L10.5218 5.06862C10.7717 5.32119 10.5928 5.75 10.2375 5.75H1.76254C1.40717 5.75 1.22826 5.32119 1.47824 5.06862L5.7157 0.787243Z"
        fill="#FFC000"
      />
      <rect x="4" y="5.5" width="4" height="4" fill="#FFC000" />
      <rect x="4" y="10.5" width="4" height="1" fill="#FFC000" />
      <rect x="4" y="12.5" width="4" height="1" fill="#FFC000" />
    </svg>
  );
};

export const ExpiringSoonIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.73926 5.39162V8.72495H11.0726M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z"
        stroke="#FDD014"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    className={props.className}
    style={{
      cursor: 'pointer',
    }}
  >
    <g clipPath="url(#clip0_8446_68142)">
      <circle
        cx="14"
        cy="14"
        r="14"
        transform="rotate(-180 14 14)"
        fill="#5661F1"
        fillOpacity="0.8"
      />
      <circle
        cx="14"
        cy="14"
        r="13.5"
        transform="rotate(-180 14 14)"
        stroke="white"
        strokeOpacity="0.2"
      />
      <path
        d="M15 10L11.7071 13.2929C11.3166 13.6834 11.3166 14.3166 11.7071 14.7071L15 18"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8446_68142">
        <rect width="28" height="28" fill="white" transform="translate(28) rotate(90)" />
      </clipPath>
    </defs>
  </svg>
);
